import { CurecallModalContainer } from '@honestica/curecall-ui'
import {
  AddPlanningTabForm,
  UpdateAllPlanningTabForm,
  UpdatePlanningTabForm,
} from '../planning-tab-form/planning-tab-form.component'
import { useTranslation } from 'react-i18next'
import { TPlanningFilters, TPlanningTab, TSearchPlanningTab } from '../planning.type'

interface AddPlanningTabModalProps {
  valuesToCopy?: Partial<TPlanningTab>
  currentFilters: TPlanningFilters
  moveToTab: (tab: TPlanningTab) => void
  onClose: VoidFunction
}
function AddPlanningTabModal({
  valuesToCopy,
  currentFilters,
  moveToTab,
  onClose,
}: Readonly<AddPlanningTabModalProps>) {
  const { t } = useTranslation()

  return (
    <CurecallModalContainer
      closeModalAriaLabel={t('common.actions.close')}
      isOpen={true}
      toggle={onClose}
      title={t('pages.planning.form.create-tab')}
    >
      <AddPlanningTabForm
        valuesToCopy={valuesToCopy}
        currentFilters={currentFilters}
        moveToTab={moveToTab}
        onClose={onClose}
      />
    </CurecallModalContainer>
  )
}

interface UpdatePlanningTabModalProps {
  planningTabToUpdate: TPlanningTab
  moveToTab: (tab: TPlanningTab) => void
  onClose: VoidFunction
}
function UpdatePlanningTabModal({
  planningTabToUpdate,
  moveToTab,
  onClose,
}: Readonly<UpdatePlanningTabModalProps>) {
  const { t } = useTranslation()

  return (
    <CurecallModalContainer
      closeModalAriaLabel={t('common.actions.close')}
      isOpen={true}
      toggle={onClose}
      title={t('pages.planning.form.update-tab', { tabName: planningTabToUpdate.label })}
    >
      <UpdatePlanningTabForm
        planningTabToUpdate={planningTabToUpdate}
        moveToTab={moveToTab}
        onClose={onClose}
      />
    </CurecallModalContainer>
  )
}

interface UpdateAllPlanningTabModalProps {
  allPlanningTab: TSearchPlanningTab
  onClose: VoidFunction
}
function UpdateAllPlanningTabModal({ allPlanningTab, onClose }: Readonly<UpdateAllPlanningTabModalProps>) {
  const { t } = useTranslation()

  return (
    <CurecallModalContainer
      closeModalAriaLabel={t('common.actions.close')}
      isOpen={true}
      toggle={onClose}
      title={t('pages.planning.form.update-all-tab')}
    >
      <UpdateAllPlanningTabForm allPlanningTab={allPlanningTab} onClose={onClose} />
    </CurecallModalContainer>
  )
}

export { AddPlanningTabModal, UpdatePlanningTabModal, UpdateAllPlanningTabModal }
